export const FETCH_PEOPLE_COUNTER = "FETCH_PEOPLE_COUNTER";